import { List } from 'immutable'
import * as lessonsActions from './actions'
import { Record } from '../transit'
import Lesson from './Lesson'

const State = Record({
  all: new List(),
  publicLessons: new List(),
  relatedLessons: [],
  currentLesson: null,
  loadedLessons: false,
  loadingLesson: false,
  loadingPublicLessons: false,
  visibleHomeworkForm: false,
  translationSuggest: [],
  wordSuggestions: [],
}, 'lessons')

const lessonsReducer = (state = new State(), action) => {
  switch (action.type) {
    case lessonsActions.LESSON_LOAD_START: {
      return state.set('loadingLesson', true)
    }
    case lessonsActions.LESSONS_LOAD_SUCCESS: {
      const lessons = new List(action.payload.data.map(item => new Lesson(item)))
      return state.set('all', lessons)
                  .set('loadedLessons', true)
    }
    case lessonsActions.SET_CURRENT_LESSON:
    case lessonsActions.LESSON_LOAD_SUCCESS: {
      const lesson = action.payload.data
      return state.set('currentLesson', new Lesson(lesson))
                  .set('loadingLesson', false)
    }
    case lessonsActions.LESSON_EDIT_SUCCESS: {
      const editedLesson = action.payload.data
      let lessons = new List(state.get('all')
        .filter(lesson =>
          lesson.id !== editedLesson.id &&
          lesson.id !== editedLesson.deletedLesson))
      lessons = lessons.push(new Lesson({ ...editedLesson }))
      return state.set('all', lessons)
    }
    case lessonsActions.LESSON_DELETE_SUCCESS: {
      const deletedID = action.payload.data._id
      const lessons = new List(state.get('all')
                                .filter(lesson => lesson.id !== deletedID))
      return state.set('all', lessons)
    }
    case lessonsActions.LESSON_CLEAR_DETAIL: {
      return state.set('currentLesson', null)
    }
    case lessonsActions.LESSON_ADD_SUCCESS: {
      const newLesson = new Lesson({ ...action.payload.data, owner: 'USER' })
      return state.set('all', state.get('all').push(newLesson))
                  .set('currentLesson', newLesson)
    }
    case lessonsActions.GET_PUBLIC_LESSONS_START: {
      return state.set('loadingPublicLessons', true)
    }
    case lessonsActions.GET_PUBLIC_LESSONS_SUCCESS: {
      const lessons = new List(action.payload.data.map(item => new Lesson(item)))
      return state.set('publicLessons', lessons).set('loadingPublicLessons', false)
    }
    case lessonsActions.LESSON_ADD_FAVORITE_SUCCESS: {
      const newLesson = new Lesson({ ...action.payload.data, owner: 'FAV' })
      const newLessonsList = state.get('all').push(newLesson)
      return state.set('all', newLessonsList  )
    }
    case lessonsActions.LESSON_REMOVE_FAVORITE_SUCCESS: {
      const deletedID = action.payload.data._id
      const lessons = new List(state.get('all')
                                .filter(lesson => lesson._id !== deletedID))
      return state.set('all', lessons)
    }
    case lessonsActions.RELATED_LESSONS_LOAD_SUCCESS: {
      const lessons = action.payload.data
      return state.set('relatedLessons', lessons)
    }
    case lessonsActions.RELATED_LESSONS_CLEAR: {
      return state.set('relatedLessons', [])
    }
    case lessonsActions.WORD_TRANSLATE_SUCCESS: {
      const { words } = action.payload.data
      return state.set('translationSuggest', words)
    }
    case lessonsActions.WORD_AUTOCOMPLETE_SUCCESS: {
      const { words } = action.payload.data
      return state.set('wordSuggestions', words)
    }
    case lessonsActions.CLEAR_SUGGESTION: {
      return state.set('translationSuggest', [])
    }
    case lessonsActions.CLEAR_AUTOCOMPLETE: {
      return state.set('wordSuggestions', [])
    }
    case lessonsActions.SHOW_HOMEWORK_FORM: {
      return state.set('visibleHomeworkForm', true)
    }
    case lessonsActions.HIDE_HOMEWORK_FORM: {
      return state.set('visibleHomeworkForm', false)
    }
    default: {
      return state
    }
  }
}

export default lessonsReducer



// WEBPACK FOOTER //
// ./src/common/lessons/reducer.js